<template lang="pug">
#app
  .columns
    .column.is-2.blog-menu(v-bind:style="background")
      aside.menu
        div(class="me-image")
        div
          p.menu-label.blog-menu-color.blog-title {{title}}
          ul.menu-list
            li
              router-link.blog-menu-color(to='/') Home
            li
              router-link.blog-menu-color(to='/about') About Me
              li(v-if="userIsLoggedIn")
                router-link.blog-menu-color(to='/newpost') New Post
            li
              a.blog-menu-color(href="mailto:renatofontes@outlook.com",
                target="_blank",rel="noopener noreferrer") Contact
    .column.main
      router-view
</template>

<script>
import '../public/stylesheets/style.sass';
import '../public/stylesheets/atom-one-dark.css';

import settings from '@/services/settingsService';
import authService from '@/services/authService';

export default {
  name: 'app',
  data() {
    return {
      background:
        settings.background && settings.background !== ''
          ? `background-image: url(${settings.background}); ${
            settings.backgroundStyle
          }`
          : '',
      title: settings.title,
      userIsLoggedIn: false,
    };
  },
  created() {
    document.title = settings.title;
    authService.$on('authChange', (user) => {
      this.userIsLoggedIn = !!user;
    });
  },
};
</script>